import { ArrowRight, LogOut } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router";
import type { ClientSession } from "../../api/auth";
import { RollText } from "./SiteHeaderNav";

export function sessionDisplayName(session: ClientSession) {
  return session.nickname?.trim() || session.phone?.trim() || session.email?.trim() || "我的账户";
}

function AccountAvatar({ url, name }: { url?: string | null; name: string }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [url]);

  return (
    <span className="site-avatar" aria-hidden="true">
      {url && !failed
        ? <img src={url} alt="" width={32} height={32} loading="lazy" onError={() => setFailed(true)} />
        : name.trim().slice(0, 1).toUpperCase() || "M"}
    </span>
  );
}

type SiteHeaderAccountProps = {
  session: ClientSession;
  loading: boolean;
  onLogout: () => void;
};

/** 岛内右侧：未登录是“登录” + “开始创作”；登录后是头像（进入工作台）与退出。 */
export function SiteHeaderAccount({ session, loading, onLogout }: SiteHeaderAccountProps) {
  if (loading) {
    return <span className="site-account-loading" role="status" aria-label="正在验证登录状态"><i /></span>;
  }

  if (!session.id) {
    return (
      <div className="site-account">
        <Link className="site-login" to="/login"><RollText text="登录" /></Link>
        <Link className="site-start" to="/moodboard">
          开始创作
          <i aria-hidden="true"><ArrowRight size={14} strokeWidth={2.2} /></i>
        </Link>
      </div>
    );
  }

  const name = sessionDisplayName(session);
  return (
    <div className="site-account">
      <Link className="site-avatar-link" to="/workbench" aria-label={`进入工作台，当前账户 ${name}`} title={name}>
        <AccountAvatar url={session.avatarUrl} name={name} />
      </Link>
      <button type="button" className="site-icon-button" onClick={onLogout} aria-label="退出登录" title="退出登录">
        <LogOut size={16} strokeWidth={1.7} />
      </button>
    </div>
  );
}
